import { useEffect } from 'react';

// Hook personnalisé pour gérer l'effet de flashlight qui suit le curseur
export const useCursorFlashlight = () => {
  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      // Mettre à jour les variables CSS qui contrôlent la position du gradient radial
      document.documentElement.style.setProperty('--cursor-x', `${event.clientX}px`);
      document.documentElement.style.setProperty('--cursor-y', `${event.clientY}px`);
    };

    // Ajouter l'écouteur d'événement de mouvement de souris
    window.addEventListener('mousemove', handleMouseMove);

    // Nettoyer l'écouteur d'événement lors du démontage du composant
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
};

export default useCursorFlashlight;